
import React from 'react';
import logo from '../images/logo.png';
import textLogo from "../images/logo-text.png";
import Background from "./Background";
const Link = require("react-router-dom").Link;

function Splash(props) {
  const { showLogin } = props;
  return (
    <div>
      <div className="splash-logo d-flex justify-content-center align-items-center">
        <div className="justify-content-center align-items-center">
          <div className="d-flex justify-content-center align-items-center flex-column">
            <div className="p-2">
              <img src={logo} height="120" width="120" className="img-fluid" alt="StudentHealthPass" />
            </div>
            <div className="pt-2 text-center text-logo">
              <img src={textLogo} height="45" width="320" className="img-fluid" alt="StudentHealthPass" />
            </div>
            <div className="slogan">
              <span>Reopen Schools&nbsp;</span>
              <span>the Safe Way</span>
            </div>
          </div>
          {
            showLogin ?
              <div className="pt-5 m-4">
                <Link className="btn button-primary btn-rounded btn-block btn-lg" to="/login">
                  LOGIN
                </Link>
              </div> : null

          }
        </div>
      </div>
      <Background path1={true} path2={true} />
    </div>
  );
}
export default Splash;